export default __webpack_public_path__ + "img/setting.fc87d5b6.svg";